import { render, staticRenderFns } from "./MailTemplateBaseDialog.vue?vue&type=template&id=f0dff8d2&scoped=true&"
import script from "./MailTemplateBaseDialog.vue?vue&type=script&lang=js&"
export * from "./MailTemplateBaseDialog.vue?vue&type=script&lang=js&"
import style0 from "./MailTemplateBaseDialog.vue?vue&type=style&index=0&id=f0dff8d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0dff8d2",
  null
  
)

export default component.exports